import { render, staticRenderFns } from "./rescueCom.vue?vue&type=template&id=6569ee80"
import script from "./rescueCom.vue?vue&type=script&lang=js"
export * from "./rescueCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports